import StayStudyPage from "../components/StayStudyPage";

export default function Stay8() {
  return (
    <StayStudyPage
      className="Class 8"
      heroTitle="Class 8 Stay & Study Program"
      heroDescription="A foundation-focused residential program preparing students for board-level academics and competitive learning."

      section1={{
        title: "📘 Board-Oriented Foundation",
        description:
          "Class 8 lays the groundwork for Class 9 and 10 board examinations.",
        points: [
          "STATE|CBSE syllabus with exam-oriented approach",
          "Strong emphasis on Maths & Science",
          "Concept clarity with numerical practice",
          "Regular unit tests and revisions",
          "Answer writing and problem-solving skills"
        ]
      }}

      section2={{
        title: "🗓️ Exam-Focused Daily Schedule",
        description:
          "A structured routine that promotes discipline and academic excellence.",
        points: [
          "Supervised self-study sessions",
          "Homework completion & revision support",
          "Balanced academics, rest & recreation",
          "Time management skill development",
          "Focused and disciplined study environment"
        ]
      }}

      whyUs={{
        title: "⭐ Why Choose ACCESS Stay & Study for Class 8?",
        description:
          "We prepare students mentally and academically for board-level challenges.",
        points: [
          "Experienced faculty for senior classes",
          "24/7 monitored residential campus",
          "Daily supervised study hours",
          "Frequent tests & performance reviews",
          "Personalized academic mentoring",
          "Safe hostel with nutritious meals",
          "Strong discipline & exam focus"
        ]
      }}

      images={{
        section1: "/images/class9-1.jpg",
        section2: "/images/class9-2.jpg",
        whyUs: "/images/Hostel2.jpeg"
      }}

      fee="80,000"
      whatsappText="Hello ACCESS Team, I would like to enquire about the Class 8 Stay & Study Program."
    />
  );
}
